import { Type } from "class-transformer";

export class DeadPersonModel {
  dpId: string;
  dpFirstName: string;
  dpLastName: string;
  dpMaidenName: string;
  @Type(() => Date) dpDateOfBirth: Date;
  dpHomeAddress: string;
  dpBsn: string;
  dpLength: string;
  dpWeight: string;
  dpBirthPlace: string;
  dpProfession: string;
  dpReligion: string;
  @Type(() => Date) dpWeddingDate: Date;
  dpPlaceOfMarriage: string;
  dpFatherName: string;
  dpIsFatherAlive: boolean;
  dpMotherName: string;
  dpIsMotherAlive: boolean;
  dpWithPassport: any;
  dpHasPassportCopy: boolean;
  dpIsJewelryTakenOff: boolean;
  dpHasLuggage: boolean;
  dpMluggageInformation: string;
  dpSignature: boolean;
  dpFuneralType: any;
  dpSpouseFirstName: string;
  dpSpouseLastName: string;
  dpSpouseDateOfBirth: Date;
  dpSpousePlaceOfBirth: string;
  dpContactPersonFirstName: string;
  dpContactPersonLastName: string;
  dpContactPersonPhoneNumber: string;
  dpContactPersonSpeaksEnglish: boolean;
  dpPostalCode: string;
  dpHouseNumber: string;
  dpHouseNumberAddition: string;
  dpStreetName: string;
  dpCity: string;
  dpCountry: string;
}